<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Insurance Patient Cost<button type="button" class="close" @click.prevent="closeModal()">
        <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="row">
          <div class="col-4 px-0 text-right">
            <h6>Patient Cost:</h6>
          </div>
          <div class="col pl-2 pr-4">
            <div v-if="noCostsDefined">
              No costs defined.
            </div>
          <div v-for="employerInsuranceCompany in employerInsuranceCompanies" :key="employerInsuranceCompany.organizationEmployerInsuranceCompanyId">
            <div v-if="employerInsuranceCompany.insuranceAmount && employerInsuranceCompany.insuranceAmount.patientPaymentType === 'FixedAmount'">
              {{employerInsuranceCompany.insuranceCompany.name + ' - $' + formatNumber(employerInsuranceCompany.insuranceAmount.patientAmount)}}<font-awesome-icon @click="removeInsuranceAmount(employerInsuranceCompany.insuranceAmount)" class="mx-1" :icon="['far', 'trash-alt']"/>
            </div>
            <div v-if="employerInsuranceCompany.insuranceAmount && employerInsuranceCompany.insuranceAmount.patientPaymentType === 'MaxOOP'">
              {{employerInsuranceCompany.insuranceCompany.name}} - Max OOP<font-awesome-icon @click="removeInsuranceAmount(employerInsuranceCompany.insuranceAmount)" class="mx-1" :icon="['far', 'trash-alt']"/>
            </div>
          </div>
        </div>
            </div>
        </div>
        </div>
      </div>
      <div class="col-2"></div>
        <hr/>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4"
                          label="Insurance Company"
                          :state="stateForField('insuranceCompany')"
                          :invalid-feedback="errorForField('insuranceCompany')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="selectedInsuranceCompanyName || 'Select Insurance Company'"
                          id="organizationEmployerInsuranceCompanyId" :variant="hasError('insuranceCompany') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="employerInsuranceCompany in employerInsuranceCompanies" :key="employerInsuranceCompany.organizationEmployerInsuranceCompanyId"
                @click.prevent="setEmployerInsuranceCompany(employerInsuranceCompany)">
                  {{ employerInsuranceCompany.insuranceCompany.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('PatientAmountRequired')"
                          :invalid-feedback="errorForField('PatientAmountRequired')"
                          label="Patient Cost Type"
                          label-class="text-right">
              <b-form-radio-group stacked class="pt-2" v-model="employerInsuranceCompany.patientPaymentType" :options="patientInsuranceAmountOptions"/>
            </b-form-group>
            <b-form-group v-if="employerInsuranceCompany.patientPaymentType === 'FixedAmount'"
                          id="amountFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('patientAmount')"
                          :invalid-feedback="errorForField('patientAmount')"
                          label="Amount"
                          label-for="amountField"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="employerInsuranceCompany.patientAmount" id="amountField"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="addEmployerInsuranceCompanyAmount()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>Add Patient Cost</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>
<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  export default {
    name: 'BundleInsurancePatientAmountModal',
    mixins: [ErrorsMixin],
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      bundleId: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        bundle: {
          bundleId: 0
        },
        patientInsuranceAmountOptions: [
          { value: 'FixedAmount', text: 'Fixed Amount' },
          { value: 'MaxOOP', text: 'Max OOP' }
        ],
        insuranceAmounts: [],
        employerInsuranceCompany: {
          patientAmount: '',
          organizationEmployerInsuranceCompanyId: 0,
          patientPaymentType: 0
        },
        employerInsuranceCompanies: [],
        selectedInsuranceCompanyName: '',
        isLoading: true,
        isSaving: false,
        organizationBundleInsuranceAmountId: 0
      }
    },

    watch: {
      visible (newValue) {
        if (newValue) {
          this.clearData()
          if (this.bundleId > 0) {
            this.loadBundle()
            this.loadEmployerInsuranceCompanies()
          }
        }
      }
    },
    computed: {
      noCostsDefined () {
        return this.employerInsuranceCompanies &&
          this.employerInsuranceCompanies.length > 0 &&
          this.employerInsuranceCompanies.every(company => company.insuranceAmount === null)
      }
    },
    methods: {
      clearData () {
        this.clearAllErrors()
        this.bundle = {
          bundleId: 0
        }
        this.employerInsuranceCompany = {
          patientAmount: '',
          organizationEmployerInsuranceCompanyId: 0
        }
        this.selectedInsuranceCompanyName = 'Select Insurance Company'
      },
      closeModal () {
        this.$emit('update:visible', false)
      },
      loadBundle () {
        this.isLoading = true
        api.get('/Dashboard/Bundle/' + this.bundleId).then(response => {
          this.bundle = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load bundle: ' + error.message, error)
          }
        }).then(() => {
          this.isLoading = false
        })
      },
      validate () {
        this.clearAllErrors()
        const amountValue = this.employerInsuranceCompany.patientAmount
        const numericRegex = /^-?\d+(\.\d+)?$/

        if (!amountValue && this.employerInsuranceCompany.patientPaymentType === 'FixedAmount') {
          this.addErrorForField('patientAmount', 'An amount is required.')
        }
        if (!numericRegex.test(amountValue) && this.employerInsuranceCompany.patientPaymentType === 'FixedAmount') {
          this.addErrorForField('patientAmount', 'Please enter a valid number.')
        }
        if (amountValue <= 0 && this.employerInsuranceCompany.patientPaymentType === 'FixedAmount') {
          this.addErrorForField('patientAmount', 'Amount must be greater then zero.')
        }

        if (!this.employerInsuranceCompany.organizationEmployerInsuranceCompanyId) {
          this.addErrorForField('insuranceCompany', 'You must select an insurance company.')
        }

        return !this.hasErrors()
      },
      loadEmployerInsuranceCompanies () {
        this.isLoading = true
        api.get('/Dashboard/Bundle/' + this.bundleId + '/EmployerInsuranceCompanies').then(response => {
          this.employerInsuranceCompanies = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load employer insurance companies: ' + error.message, error)
          }
        }).then(() => {
          this.isLoading = false
        })
      },
      setEmployerInsuranceCompany (employerInsuranceCompany) {
        this.selectedInsuranceCompanyName = employerInsuranceCompany.insuranceCompany.name
        this.employerInsuranceCompany.organizationEmployerInsuranceCompanyId = employerInsuranceCompany.organizationEmployerInsuranceCompanyId
      },
      addEmployerInsuranceCompanyAmount () {
        if (this.isSaving) {
          this.isSaving = true
        }
        if (!this.validate()) {
          return
        }
        const selectedInsuranceCompanyId = this.employerInsuranceCompany.organizationEmployerInsuranceCompanyId
        const existingAmount = this.employerInsuranceCompanies.some(company =>
          company.organizationEmployerInsuranceCompanyId === selectedInsuranceCompanyId &&
          company.insuranceAmount && Object.keys(company.insuranceAmount).length > 0
        )
        if (existingAmount) {
          this.addErrorForField('exception', 'An patient cost already exists for this company.')
          return
        }
        api.post('/Dashboard/Bundle/' + this.bundleId + '/EmployerInsuranceCompanies', this.employerInsuranceCompany).then(response => {
          this.employerInsuranceCompanies = response.data.employerInsuranceCompanies
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to add employer insurance company amount: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
          this.loadEmployerInsuranceCompanies()
          this.employerInsuranceCompany = {
            patientAmount: '',
            organizationEmployerInsuranceCompanyId: 0
          }
          this.selectedInsuranceCompanyName = 'Select Insurance Company'
        })
      },
      removeInsuranceAmount (insuranceAmount) {
        this.clearAllErrors()
        api.delete('/Dashboard/Bundle/EmployerInsuranceCompanies/' + insuranceAmount.organizationBundleInsuranceAmountId).then(response => {
          this.loadBundle()
          this.loadEmployerInsuranceCompanies()
          this.clearData()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to remove service: ' + error.message, error)
          }
        })
      },
      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '0.00'
        }
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return ''
      }

    }
  }
</script>
<style scoped>
  #organizationEmployerInsuranceCompanyId {
    max-width: 300px;
  }
</style>
